<template>
  <base-list-item class="scs-contact-automation-list-item">
    <div class="automation-list-item-left-side">
      <p>{{ eventName }}</p>
      <p>{{ automation.title }}</p>
    </div>
    <div class="automation-list-item-right-side">
      <p>{{ executionTime }}</p>
      <div class="icons">
        <!-- todo : popup modal to preview automation -->
        <!-- todo : add delete automation ability -->
        <!-- <round-button-with-icon class="icon" icon="eye-open" /> -->
        <round-button-with-icon
          v-if="!automation.approved"
          class="icon"
          :icon="automation.processing ? 'spinner' : 'checkmark'"
          @click="approveAutomation(automation)"
        />
      </div>
    </div>
  </base-list-item>
</template>
<script>
// todo : wire up buttons to actions
import BaseListItem from "../BaseListItem.vue";
import RoundButtonWithIcon from "../../RoundButtonWithIcon.vue";
import { formatDate, formatTime } from "../../../../Helpers/invoice.js";
export default {
  data() {
    return {};
  },
  computed: {
    eventName() {
      if (this.contact.eventsRetrieved) {
        let subjectEvent = this.contact.associatedEvents.find((x) => {
          return x.userId == this.automation.eventId;
        });
        return subjectEvent
          ? subjectEvent.title
            ? subjectEvent.title
            : "..."
          : "...";
      } else {
        return "...";
      }
    },
    executionTime() {
      if (this.contact.eventsRetrieved) {
        return `${formatDate(
          new Date(this.automation.triggerDate)
        )} at ${formatTime(new Date(this.automation.triggerDate))}`;
      } else {
        return "...";
      }
    },
  },
  methods: {
    async approveAutomation(automation) {
      automation.processing = true;
      await this.$store.dispatch("approveAutomation", automation.id);
      automation.processing = false;
      automation.approved = true;
    },
  },
  components: {
    BaseListItem,
    RoundButtonWithIcon,
  },
  props: ["automation", "contact"],
};
</script>
<style scoped>
.scs-contact-automation-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
}

.automation-list-item-right-side,
.automation-list-item-left-side {
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.automation-list-item-left-side {
  text-align: left;
}

.automation-list-item-right-side {
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

p {
  font-size: 0.65rem;
}

.icon {
}

.icons {
  display: flex;
  justify-content: flex-end;
  width: 100px;
}
</style>
